import React from 'react';
import {
  FeaturedPackagingCard,
  FeaturedPackagingSupplierCard,
  PackagingCard,
  PackagingKind,
} from '@/shared/types/featured-packaging';
import { logCommonView } from '@/lib/service';
import { EventSource } from '@/shared/constants/event';
import { getSupplierName } from '@/shared/utils/sourcing-marketplace-util';
import { CatalogCompany } from '@/shared/types/catalog';
import { useCreateAccountProvider } from '@/lib/context';
import queryString from 'query-string';
import { ParamKey } from '@/shared/types/url-params';
import { SourcingHomeTab } from '@/shared/types/sourcing-marketplace';
import { CUSTOM_PACKAGING_DESCRIPTION } from '@/shared/constants/sourcing-marketplace';
import FeaturedPackagingCardElement from './FeaturedPackagingCardElement';
import { LogisticsFeeRate } from '@/shared/types/store';
import { map } from 'lodash-es';
import './index.less';

interface IProps {
  data: PackagingCard[];
  logisticsFeeRateLadder: LogisticsFeeRate[];
}

const PackagingCardsList = ({ data, logisticsFeeRateLadder }: IProps) => {
  const { showSignupDialogFromSourcing } = useCreateAccountProvider();

  const onPackagingClick = async (card: FeaturedPackagingCard) => {
    logCommonView(EventSource.FEATURED_PACKAGING_STARTING_POINT_CLICK, card.title);
    showSignupDialogFromSourcing(
      CUSTOM_PACKAGING_DESCRIPTION,
      queryString.stringifyUrl({
        url: '/home',
        query: {
          [ParamKey.HOMEPAGE_CATEGORY]: SourcingHomeTab.PACKAGING,
        },
      }),
      'category_starting_points',
      'public_sourcing_marketplace',
    );
  };

  const renderPackagingCard = (card: PackagingCard, i: number) => {
    const featuredPackagingCard = card as FeaturedPackagingSupplierCard;
    const supplierName = getSupplierName({ name: featuredPackagingCard.supplierName } as CatalogCompany);

    return card.kind === PackagingKind.FEATURED ? (
      <FeaturedPackagingCardElement
        key={(card as FeaturedPackagingCard).key}
        cardInfo={card}
        selectTitle="Select a size"
        buttonTitle="Continue"
        bundleLogisticsFee={true}
        logisticsFeeRateLadder={logisticsFeeRateLadder}
        onNext={(size: string, quantity: number) => {
          onPackagingClick(card as FeaturedPackagingCard);
        }}
      />
    ) : (
      <FeaturedPackagingCardElement
        cardInfo={card}
        key={i}
        selectTitle={supplierName}
        buttonTitle={`Chat with ${supplierName}`}
        bundleLogisticsFee={false}
        logisticsFeeRateLadder={logisticsFeeRateLadder}
        onNext={(size: string, quantity: number) => {
          onPackagingClick(card as FeaturedPackagingCard);
        }}
      />
    );
  };

  return (
    <div className="packaging-cards-list">
      <div className="grid">{map(data, (card: PackagingCard, i: number) => renderPackagingCard(card, i))}</div>
    </div>
  );
};

export default PackagingCardsList;
